import { displayToast, initializeModals, sendAppsignalError } from "../modules/utils";
import Swiper from "swiper";

class Funnel {
  constructor(node) {
    this.element = node;

    this.searchInputs = this.element.querySelectorAll(".js-funnel-search-input");
    this.contentWrappers = this.element.querySelectorAll(".js-content-wrapper");
    this.searchWrappers = this.element.querySelectorAll(".js-funnel-search-wrapper");
    this.generalWrapper = this.element.querySelector(".js-general-wrapper");
    this.connnectionSelect = this.element.querySelector(".js-connections-wrapper");
    this.idInput = this.element.querySelector(".js-funnel-id");

    this.searchResultUrl = new URL(this.element.dataset.searchResultUrl, window.location.origin);

    this.initialize();
  }

  initialize() {
    this.initializeFilter();
    this.initializeSwiper(this.generalWrapper.querySelector(".js-funnel-status-swiper"));

    const currentUrl = new URL(document.location);

    currentUrl.searchParams.forEach((value, key) => {
      this.searchResultUrl.searchParams.set(key, value);
    });

    this.searchInputs.forEach((searchInput) => {
      const url = new URL(window.location.href);
      this.query = url.searchParams.get("query") || "";

      searchInput.value = this.query;

      searchInput.addEventListener("input", (e) => {
        this.query = e.target.value.trim();

        this.throttledFetch(400);
      });
    });

    this.contentWrappers.forEach((contentWrapper) => {
      contentWrapper.addEventListener("ajax:post", (e) => {
        this.fillContentWrapper(e.detail);
      });
    });

    this.connnectionSelect.addEventListener("change", (e) => {
      window.location.href = e.target.value;
    });

    window.addEventListener("checkboxForm:updated", (e) => {
      this.fillContentWrapper(e.detail);
    });

    window.addEventListener("beyuna-classes-initialized", () => {
      this.dropdownFilterInstance = window.Beyuna.objects["custom-select"]["funnel"];
    });

    window.addEventListener("popstate", () => {
      const url = new URL(window.location.href);

      url.searchParams.forEach((value, key) => {
        this.searchResultUrl.searchParams.set(key, value);
      });

      this.query = url.searchParams.get("query") || "";

      this.searchInputs.forEach((searchInput) => {
        searchInput.value = this.query;
      });

      if (this.dropdownFilterInstance) {
        this.dropdownFilterInstance.inputElement.value = url.searchParams.get(this.funnelFilter.name);

        if (this.dropdownFilterInstance.dropdownVisible) {
          this.dropdownFilterInstance.toggleDropdown();
        }

        this.searchResultUrl.searchParams.set("filter", this.dropdownFilterInstance.inputElement.value);
      }

      this.searchResultUrl.searchParams.set("query", this.query);
      this.fetchResults();
    });
  }

  fillContentWrapper(html) {
    for (const [key, value] of Object.entries(html)) {
      const contentWrappers = this.element.querySelectorAll(`.js-${key}-wrapper`);

      contentWrappers.forEach((contentWrapper) => {
        if (key === "general") {
          // We must close the old dropdown instance before initializing a new one
          const dropdownInstance = window.Beyuna.objects["custom-select"].options;
          dropdownInstance.toggleDropdown();
        }

        contentWrapper.innerHTML = value;
        window.Beyuna.initClasses(contentWrapper);
        initializeModals(contentWrapper);

        if (key === "general") {
          this.initializeSwiper(contentWrapper.querySelector(".js-funnel-status-swiper"));
        }
      });
    }
  }

  initializeFilter() {
    this.funnelFilter = this.element.querySelector(".js-funnel-filter");

    this.funnelFilter.addEventListener("change", (e) => {
      const currentUrl = new URL(document.location);
      currentUrl.searchParams.set(e.target.name, e.target.value);
      currentUrl.searchParams.set("query", this.query);
      window.history.pushState({}, "", currentUrl);

      this.searchResultUrl.searchParams.set(e.target.name, e.target.value);
      this.searchResultUrl.searchParams.set("query", this.query);
      this.searchResultUrl.searchParams.set("id", this.idInput.value);

      this.fetchResults();
    });
  }

  initializeSwiper(target) {
    if (target === undefined) {
      return;
    }

    const swiper = new Swiper(target, {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      grabCursor: true,
      initialSlide: this.element.dataset.initialSlideIndex || 0,
    });

    swiper.on("slideChange", (e) => {
      this.searchResultUrl.searchParams.set("slide", e.activeIndex - 1);
      this.searchResultUrl.searchParams.set("id", this.idInput.value);
      this.searchResultUrl.searchParams.set("CurrentPhase", e.activeIndex - 1);
      this.fetchResults();
    });
  }

  throttledFetch(delay) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.searchResultUrl.searchParams.set("query", this.query);

      const currentUrl = new URL(document.location);
      currentUrl.searchParams.set("query", this.query);
      window.history.pushState({}, "", currentUrl);

      this.fetchResults();
    }, delay);
  }

  fetchResults() {
    this.searchWrappers.forEach((searchWrapper) => {
      searchWrapper.classList.add("is-loading");
    });

    fetch(this.searchResultUrl, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        this.fillContentWrapper(data);

        this.initializeFilter();

        const scrollArrows = document.querySelectorAll("[data-js-class='scroll-arrows']");
        scrollArrows.forEach((scrollArrow) => {
          window.Beyuna.initClasses(scrollArrow.parentElement); // Parent element since it checks the children
        });
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "Funnel", {
          response: this.response,
        });
      })
      .finally(() => {
        this.searchResultUrl.searchParams.delete("slide");

        this.searchWrappers.forEach((searchWrapper) => {
          searchWrapper.classList.remove("is-loading");
        });
      });
  }
}

const funnelElement = document.querySelector("[data-js='funnel']");

if (funnelElement) {
  new Funnel(funnelElement);
}
